/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Process transactions and manage subscriptions`)
};

const es_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesar transacciones y administrar suscripciones`)
};

const de_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transaktionen zu verarbeiten und Abonnements zu verwalten`)
};

const nl_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transacties te verwerken en abonnementen te beheren`)
};

const fr_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Traiter les transactions et gérer les abonnements`)
};

const it_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborare transazioni e gestire abbonamenti`)
};

const pt_br2_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processar transações e gerenciar assinaturas`)
};

const pt_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processar transações e gerir subscrições`)
};

const ja_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取引の処理とサブスクリプションの管理`)
};

const zh_privacy_use_3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理交易和管理订阅`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const privacy_use_3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.privacy_use_3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("privacy_use_3", locale)
	if (locale === "en") return en_privacy_use_3(inputs)
	if (locale === "es") return es_privacy_use_3(inputs)
	if (locale === "de") return de_privacy_use_3(inputs)
	if (locale === "nl") return nl_privacy_use_3(inputs)
	if (locale === "fr") return fr_privacy_use_3(inputs)
	if (locale === "it") return it_privacy_use_3(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_use_3(inputs)
	if (locale === "pt") return pt_privacy_use_3(inputs)
	if (locale === "ja") return ja_privacy_use_3(inputs)
	return zh_privacy_use_3(inputs)
};